import { DOCUMENT_MODEL, KNOWLEDGE_SCOPE } from "src/app/contract-management/models/contract-management.model";
import { FILE_GROUP } from "src/app/features/general-agent/models/types";

export interface AttachmentFilterChip {
    label: string;
    docModel: 'ALL' | FILE_GROUP | DOCUMENT_MODEL | string;
}

export const KNOWLEDGE_CATEGORY = {
    PROJECT: 'PROJECT_KNOWLEDGE',
    WORKSPACE: 'WORKSPACE_KNOWLEDGE',
} as const;

export function resolveKnowledgeCategory(scope?: string, metadata?: Record<string, any> | null): string {
    if (metadata?.['isProjectKnowledge']) return KNOWLEDGE_CATEGORY.PROJECT;
    if (metadata?.['kbId']) return KNOWLEDGE_CATEGORY.WORKSPACE;
    return scope === KNOWLEDGE_SCOPE.PROJECT
        ? KNOWLEDGE_CATEGORY.PROJECT
        : KNOWLEDGE_CATEGORY.WORKSPACE;
}
